import React from 'react';
import {Link} from "react-router-dom";

import AdminLayout from 'Pages/Admin/AdminLayout';

import {PrimaryButton, SecondaryButton} from 'Components/Button';
import {FormHandler, Input, Select, Toggle} from 'Components/Form';
import {Alert, Loading} from 'Components/Partials';

import FrequencyOptions from 'Config/ScheduledReportFrequencyOptions';

import AdminScheduledReportsApi from 'Services/Api/Admin/ScheduledReports';

class Store extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Scheduled Report ' + (this.props.match?.params?.scheduledReport ? 'updated' : 'created') + ' successfully';

    /**
     * @var state
     * @type {{scheduled_report_id: string}}
     */
    state = {
        scheduled_report_id: this.props.match?.params?.scheduledReport ?? ''
    };

    /**
     * @method componentDidMount
     */
    componentDidMount() {        
        if (this.state.scheduled_report_id) {
            this.loadData();
        } else {
            this.props.setInitialValues({
                enabled: true
            });
        }
    }

    /**
     * @method loadData
     */
    loadData = async () => {
        const {scheduled_report_id} = this.state;

        const response = await AdminScheduledReportsApi.get(scheduled_report_id);

        this.props.setForm(response.data.data);
    }

    /**
     * @method handleSubmit
     * @param {object} form
     * @return {Promise<*>}
     */
    handleSubmit = (form) => {
        const {scheduled_report_id} = this.state;

        if (scheduled_report_id) {
            return AdminScheduledReportsApi.patch(scheduled_report_id, form);
        } else {
            return AdminScheduledReportsApi.post(null, form);
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() { 
        const {scheduled_report_id} = this.state;
        const {form, working, alert, handleInput, getFieldError, handleSubmit} = this.props;

        return (
            <AdminLayout title={'Scheduled Reports - ' + (scheduled_report_id ? 'Update' : 'Create')}>
                <form
                    className="divide-y divide-gray-200"
                    onSubmit={(e) => handleSubmit(e, this.handleSubmit, this.success, !scheduled_report_id)}
                >
                    <div className="mx-6">
                        {alert !== null && (<Alert {...alert} />)}

                        <div className="grid grid-cols-1 gap-4 mb-4">
                            <Input
                                label="Title"
                                value={form.title}
                                error={getFieldError('title')}
                                onChange={(v) => handleInput('title', v)}
                            />

                            <Select
                                label="Frequency"
                                value={form.frequency}
                                error={getFieldError('frequency')}
                                onChange={(v) => handleInput('frequency', v)}
                                options={FrequencyOptions}
                            />

                            <Select
                                label="Emails"
                                value={form.emails}
                                error={getFieldError('emails')}
                                onChange={(v) => handleInput('emails', v)}
                                isMulti
                                isCreatable
                            />

                            <Toggle
                                label="Enabled"
                                value={form.enabled}
                                error={getFieldError('enabled')}
                                onChange={v => handleInput('enabled', v)}
                                labelPlacement="top"
                            />
                        </div>
                    </div>

                    <div className="px-6 pt-6 flex justify-end gap-4">
                        <Link to="/admin/scheduled-reports">
                            <SecondaryButton type="button" text="Back" />
                        </Link>

                        <PrimaryButton
                            text="Save"
                            working={working}
                        />
                    </div>
                </form>
            </AdminLayout>
        )
    }
}

export default FormHandler(Store);